export const baseUrl =
  process.env.REACT_APP_BASE_URL || 'https://eatly-api.onrender.com'
export const squareApplicationId = process.env.REACT_APP_SQUARE_APPLICATION_ID;
export const squareLocationId = process.env.REACT_APP_LOCATION_ID;